import { Box, Paper, Grid, Typography } from "@material-ui/core";
import React from "react";
import Logo from "../../../Logo/Logo";
import { useWelcomeMessageStyle } from "../../hooks/useWelcomeMessageStyle";

export const WelcomeBackMessageHeader = ({ hidingLogo, hidingMessage }) => {
  const { circleBoxWidth, circleLogoHeight, circleLogoWidth } =
    useWelcomeMessageStyle({ hidingMessage });

  return (
    <Box
      zIndex={"modal"}
      className={hidingLogo ? "disappear-anim" : "appear-anim"}
      width={"100%"}
      height={"100%"}
      left={0}
      top={0}
      position={"absolute"}
      display={"flex"}
      style={{ pointerEvents: hidingLogo ? "none" : "inherit" }}
    >
      <Paper elevation={0} className={"w-100 text-center"}>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          className={"h-100"}
        >
          <Grid item>
            <Typography color={"primary"} variant={"h6"} className={"mb-3"}>
              <Box
                display="flex"
                alignItems="center"
                justifyContent={"center"}
                className={"circle-border-appear-anim"}
                style={{
                  borderRadius: "100px",
                  height: `${circleBoxWidth}px`,
                  width: `${circleBoxWidth}px`,
                }}
              >
                <Logo height={circleLogoHeight} width={circleLogoWidth} />
              </Box>
            </Typography>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};
